const zhCN = {
  backBtn: '返回',
  submitBtn: '提交',

  activeTimeTitle: '门禁有效时间',

  selectTimeConfig: '选择有效时间配置',
  selectTimeConfigTxt: '请选择门禁有效时间配置'

  // option_closedDoor: '不开门',
  // getTimeConfigFail: '获取门禁有效时间配置项失败！',  
  // getValidTimeFail: '获取该门禁的有效时间配置失败！',

  // validTimeSelectionTxt: 'return "请选择" + type + "的开门时间"',
  // validTimeSelectionWarning: 'return "请选择" + type + "的开门时间！"',
}
const enUS = {
  backBtn: 'Back',
  submitBtn: 'Submit',

  activeTimeTitle: 'Active Time Settings',

  selectTimeConfig: 'Select Time Configuration',
  selectTimeConfigTxt: 'Please select the time configuration'

  // option_closedDoor: 'Closed',
  // getTimeConfigFail: 'Get effective time configuration item failed!',
  // getValidTimeFail: 'Get the valid time configuration of this gate failed!',

  // validTimeSelectionTxt: 'return "Choose the opening time on " + type',
  // validTimeSelectionWarning: 'return "Opening time on " + type + " can\'t be blank!"',
}

export default { zhCN, enUS }